module.exports = __webpack_public_path__ + "img/mascani-l.ac905013.jpg";